import React from 'react';
export function BioSection() {
  return <section id="meet" className="bg-white py-20" data-id="element-5">
      <div className="max-w-4xl mx-auto px-8" data-id="element-6">
        <h2 className="text-4xl lg:text-5xl font-bold text-blue-800 mb-12 text-center" data-id="element-7">
          MEET JUSTIN
        </h2>

        <div className="space-y-6 text-blue-900 text-lg leading-relaxed" data-id="element-8">
          <p data-id="element-9">
            Justin is a millennial "boomerang" — a Cleveland native, educated in
            public schools, and a proud graduate of Cleveland State University.
          </p>

          <p data-id="element-10">
            Justin left Cleveland in 2007 to work on then-Senator Barack Obama's
            presidential campaign. For more than a year, Justin worked as a
            field organizer throughout the country. This journey instilled in
            him the value of community-driven political organizing—a lesson he
            took with him as he ultimately went on to work for Democratic
            candidates at every level of government in 13 states.
          </p>

          <p data-id="element-11">
            He carried those lessons into government in 2015 as a legislative
            aide in the Virginia State Senate. During his tenure, Justin worked
            with dozens of community groups and saw firsthand how corporate
            special interests tried to overcome the public interest, and what
            can happen when the people push back.
          </p>

          <p data-id="element-12">
            That experience led him to serve as a public-interest federal policy
            lobbyist in Washington, DC. Over that time, Justin became well
            versed and accomplished on issues ranging from progressive taxation
            and campaign finance to criminal justice and cannabis legalization.
          </p>

          <p data-id="element-13">
            Whether it was managing Democratic campaigns or running the vote
            whip for the first ever bill to pass in the US House of
            Representatives that would end marijuana criminalization, the
            people-part of politics always came first.
          </p>

          <p data-id="element-14">
            But his heart was always here in Cleveland. With the dysfunction of
            Washington, DC only getting worse by the year, the pandemic offered
            Justin's family the opportunity to return home.
          </p>

          <p data-id="element-15">
            Since returning to Cleveland in 2020, Justin joined the Guardians
            for Fair Work campaign which spearheaded Cleveland and Cuyahoga's
            efforts to hold employers that steal from their workers accountable.
            He has also been appointed by local leaders to serve on the Steering
            Committee of the Cuyahoga County Progressive Caucus (CCPC) and on
            the Executive Committee of the Cuyahoga County Democratic Party
            (CCDP).
          </p>

          <p data-id="element-16">
            All of this is in hopes of building a happier, equitable, and
            justice-centered hometown.
          </p>

          <p data-id="element-17">
            Most recently, Justin has worked as a federal contractor with the
            NASA backed effort known as COSMIC (The Consortium for Space
            Mobility and ISAM Capabilities), to accelerate adoption of In-space
            Servicing, Assembly, and Manufacturing (ISAM) capabilities and build
            a sustainable, scalable, and safe space ecosystem.
          </p>

          <p data-id="element-18">
            In his free time, Justin enjoys going to the batting cages, hanging
            out at his neighborhood dive bar with wife Dana and their
            friends, and walking their dog Wags.
          </p>
          <p data-id="element-19">You can <b data-id="element-20"><a href="https://actionnetwork.org/forms/be-a-part-from-the-start/" data-id="element-21">sign up for campaign updates here.</a></b></p>
          <p data-id="element-22">Click <b data-id="element-23"><a href="mailto: info@justinforus.com" data-id="element-24">here to contact the campaign.</a></b></p>
          <div className="flex justify-center" data-id="element-25">
            <a href="https://secure.actblue.com/donate/justinforus" data-id="element-26">
              <button className="bg-red-600 hover:bg-red-700 text-white font-bold text-xl px-12 py-4 transition-colors" data-id="element-27">
                DONATE
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}